export default __webpack_public_path__ + "static/Prostatizal-Plus-home-@2x-92be60a837ce5f2a21df3e725a66c5ed.jpg";